<app-header></app-header>
<main class="mt-[68px] relative min-h-[calc(100vh-68px)]">
  <ngx-spinner type="ball-running-dots" [fullScreen]="false">
    <div class="w-full text-center">
      <button
        class="text-white mt-4 cursor-pointer hover:scale-110 transition-transform"
        (click)="abort()"
        appAgentAction
        agent="app-abort"
        action="abort"
      >
        <app-cancel-icon></app-cancel-icon>
      </button>
      <p class="text-white text-xs">Cancel</p>
    </div>
  </ngx-spinner>

  <app-unsaved-changes-modal #unsavedChangesModal></app-unsaved-changes-modal>
  <router-outlet></router-outlet>
</main>
